import { useLocalStorageManager } from '@0x234/common-vue/storage/local-storage-manager';
import { defineStore } from 'pinia';
import { Dark } from 'quasar';
import { ref, watchEffect } from 'vue';

export const useAppStore = defineStore('app', () => {
    const localStorageManager = useLocalStorageManager();

    const darkMode = localStorageManager.storeRef('app/darkMode', 'auto');

    const drawerIsOpen = ref(false);

    const newVersionServiceDialog = ref(null);
    const unavailableServiceDialog = ref(null);

    function _toggleColorSchemeMetaTag() {
        if (!import.meta.env.QUASAR_CLIENT) {
            return;
        }
        const metaTag = document.querySelector('meta[name="color-scheme"]');
        if (Dark.isActive && !metaTag) {
            const meta = document.createElement('meta');
            meta.name = 'color-scheme';
            meta.content = 'dark';
            document.head.appendChild(meta);
        } else if (!Dark.isActive && metaTag) {
            metaTag.remove();
        }
    }

    function watchForThemeChanges() {
        if (!import.meta.env.QUASAR_CLIENT) {
            return;
        }
        watchEffect(() => {
            darkMode.value = Dark.mode;
            _toggleColorSchemeMetaTag();
        });
    }

    return {
        darkMode,
        drawerIsOpen,
        newVersionServiceDialog,
        unavailableServiceDialog,
        watchForThemeChanges
    };
}, {
    preventHydrate: [
        'darkMode',
        'drawerIsOpen',
        'newVersionServiceDialog',
        'unavailableServiceDialog'
    ]
});
